import styled from 'styled-components';

interface ModalAchiviementProps {
  bgImage: string;
}

export const Container = styled.div`

`;

export const ModalAchiviementContainer = styled.section<ModalAchiviementProps>`
  margin: -1.55rem -1.55rem 0 -1.55rem;

  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    width: 100%;
    text-align: center;
    padding: 1.5rem 0 0 0;
  }

  > main {
    padding: 1rem 2rem 2rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > h1 {
      font-size: 1.5rem;
      margin-bottom: 1rem;
      color: ${props => props.theme.colors.white};
    }
    
    > p {
      text-align: center;
      font-size: 14px;
      margin-bottom: 0.5rem;
      line-height: 1.5;
      display: block;
      height: fit-content;
      color: ${props => props.theme.colors.white};
      font-weight: 500;
    }

    > footer {
      display: flex;
      width: fit-content;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 1rem;

      > h6 {
        font-size: 12px;
        margin-bottom: 0.5rem;
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.muted}20;
        border-radius: 50px;
        padding: 0.25rem 1rem;
      }

      > p {
        font-size: 11px;
        color: ${props => props.theme.colors.muted};
      }
    }
  }
`;
